import JobInput from 'components/JobInput';
import React from 'react';
import { Create, SimpleForm, DateTimeInput, NumberInput } from 'react-admin';

const BreaksCreate = () => (
  <Create>
    <SimpleForm>
      <DateTimeInput source="starts_time" />
      <NumberInput source="duration_minutes" />
      <JobInput />
    </SimpleForm>
  </Create>
);

export default BreaksCreate;
